let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gkdtJ")).then(() => parcelRequire('1ygpC'));